
/*仓储物流管理系统*/

/*主容器文件*/
const main = () =>  import("../../../studio/sub_systems/policyNews/policy_system_main");

/*仓储物流管理  首页子系统*/
const main_container = () =>  import("../../../studio/sub_systems/policyNews/index_page/index_page_main");
// 农资资讯
const agroNews = () =>  import("../../../studio/sub_systems/policyNews/index_page/agroNews/index");
// 市场行情
const marketCondition = () =>  import("../../../studio/sub_systems/policyNews/index_page/marketCondition/index");
// 市场行情
const marketPrice = () =>  import("../../../studio/sub_systems/policyNews/index_page/marketPrice/index");



export default [
  {
    path: '/policyNews',
    name: '资讯发布系统',
    redirect: '/policyNews/index',
    component: main,
    children: [
      {
        path: '/policyNews/index',
        redirect: '/policyNews/index/agroNews',
        name: '首页',
        component: main_container,
        children:[
          {
            path: '/policyNews/index/agroNews',
            name: '农资资讯',
            component: agroNews ,
          },
          {
            path: '/policyNews/index/marketCondition',
            name: '市场行情',
            component: marketCondition ,
          },
          {
            path: '/policyNews/index/marketPrice',
            name: '市场价格',
            component: marketPrice ,
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/policyNews/policy_system_page.js